import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'
interface IStockDetail {
  /**
   * 股票代码，不带后缀，如 600570
   */
  stockCode: string
  /**
   * 一级市场类型
   */
  marketType: string
  /**
   * 二级市场类型
   */
  subMarketType: string
  /**
   * 股票名称
   */
  stockName?: string
  success?: (result?: IStockDetail) => void
  fail?: (result?: IStockDetail) => void
  complete?: (result?: IStockDetail) => void
}

/**
 * 跳转个股详情
 * @param stockCode 股票代码
 * @param stockName 股票名称
 * @param marketType 一级市场类型
 * @param subMarketType 二级市场类型
 */
function navigateToStockDetailSync({
  stockCode = '',
  stockName = '',
  marketType = '',
  subMarketType = '',
  success,
  fail,
  complete
}: IBridgeOptions<IStockDetail>) {
  const params = formatParams({
    funType: 'forward',
    funName: 'forwardStockDetail',
    stockCode: `${stockCode}`,
    marketType: `${marketType}`,
    subMarketType: `${subMarketType}`
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('navigateToStockDetail error: ', error)
  }
}

/**
 * 跳转个股详情<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @param {IBridgeOptions<IStockDetail>} {
 *   stockCode = '',
 *   stockName = '',
 *   marketType = '',
 *   subMarketType = ''
 * }
 * @returns
 */
function navigateToStockDetail({
  stockCode = '',
  stockName = '',
  marketType = '',
  subMarketType = ''
}: IBridgeOptions<IStockDetail>) {
  const params = formatParams({
    funType: 'forward',
    funName: 'forwardStockDetail',
    stockCode: `${stockCode}`,
    marketType: `${marketType}`,
    subMarketType: `${subMarketType}`
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }
  return nativeJSBridge(opts)
}

export { navigateToStockDetail, navigateToStockDetailSync }
